<template>
  <AdminLayout><CancelledOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import CancelledOrdersTable from './CancelledOrdersTable.vue';

export default {
  name: 'CancelledOrders',
  components: { AdminLayout, CancelledOrdersTable },
};
</script>
